import { useState, useEffect, useRef } from "react";

import { FaCommentAlt, FaTimes } from "react-icons/fa";
const faqData = [
    {
        question: "Que faire après ma première connexion ?",
        answer:
            "Commencez par compléter votre profil dans la section Profil & Abonnement. Remplissez toutes les informations obligatoires de votre société : nom commercial, statut juridique, logo, SIRET (obligatoire et unique), TVA et email principal (unique). Ces informations sont essentielles pour créer des devis et factures conformes."
    },
    {
        question: "Comment ajouter un client ?",
        answer:
            "Avant de créer un devis ou une facture, ajoutez au moins un client dans la liste des clients. Cliquez sur 'Ajouter un client' et remplissez les informations nécessaires."
    },
    {
        question: "Comment créer un devis ?",
        answer:
            "Après avoir ajouté un client, rendez-vous dans la section Devis. Chaque devis reçoit un numéro unique (ex : DEV-0001). Vous pouvez transformer le devis en facture via le bouton 'Transformer en facture'."
    },
    {
        question: "Comment générer et télécharger un PDF ?",
        answer:
            "Pour chaque devis ou facture, utilisez le bouton PDF pour télécharger le document. Cela permet de partager facilement vos documents avec vos clients."
    },
    {
        question: "Comment personnaliser le PDF ?",
        answer:
            "Vous pouvez configurer vos PDF en choisissant si vous souhaitez inclure le logo de votre société et la couleur du PDF. Cela permet de créer des documents professionnels et cohérents avec votre identité visuelle."
    },
    {
        question: "Comment relancer une facture impayée ?",
        answer:
            "Dans la liste des factures, cliquez sur 'Relancer' et personnalisez le message avant l'envoi. Les relances suivantes sont automatiques tous les 15 jours tant que le statut de la facture reste non payé."
    },
    {
        question: "Quelles informations sont importantes pour la TVA ?",
        answer:
            "Assurez-vous que le SIRET et le numéro de TVA sont corrects dans votre profil. Ces informations apparaîtront sur tous vos devis et factures officiels."
    },
    {
        question: "Puis-je utiliser un téléphone pour gérer mes documents ?",
        answer:
            "Il est recommandé d’utiliser un ordinateur pour configurer le profil, ajouter des clients et créer des devis/factures afin d’éviter les erreurs et profiter d’une meilleure expérience utilisateur."
    },
    {
        question: "Autre",
        answer: "Contactez-nous par mail : contact@gestionfreelance.com"
    }
];
const ChatFAQ = () => {
    const [open, setOpen] = useState(false);
    const [messages, setMessages] = useState([]);
    const [typing, setTyping] = useState(false);
    const messagesEndRef = useRef(null);

    // Fonction pour afficher le message mot par mot
    const addBotMessage = (text) => {
        setTyping(true);
        const words = text.split(" ");
        let i = 0;
        setMessages((prev) => [...prev, { sender: "bot", text: "" }]);
        const interval = setInterval(() => {
            i++;
            setMessages((prev) => {
                const newMessages = [...prev];
                newMessages[newMessages.length - 1].text = words.slice(0, i).join(" ");
                return newMessages;
            });
            if (i === words.length) {
                clearInterval(interval);
                setTyping(false);
            }
        }, 200);
    };

    const handleStart = () => {
        if (!typing) addBotMessage("Bonjour ! Je suis votre assistant FAQ.");
    };

    const handleQuestionClick = (q) => {
        if (typing) return;
        setMessages((prev) => [...prev, { sender: "user", text: q.question }]);
        setTimeout(() => addBotMessage(q.answer), 300);
    };

    // Scroll automatique vers le bas quand un message est ajouté
    useEffect(() => {
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }, [messages]);

    return (
        <>
            {!open && (
                <button
                    className="fixed bottom-5 right-5 bg-color1 text-white p-4 rounded-full shadow-lg hover:bg-color1/90 transition"
                    onClick={() => setOpen(true)}
                >
                    <FaCommentAlt size={24} />
                </button>
            )}

            {open && (
                <div className="fixed bottom-0 right-0 md:right-10 md:bottom-10 w-[80%] md:w-[25%] h-[70vh] md:h-[60vh] bg-white rounded-xl shadow-xl flex flex-col">
                    {/* Header */}
                    <div className="flex justify-between items-center bg-color1 text-white p-3">
                        <h2 className="text-sm font-bold">Assistant FAQ</h2>
                        <button onClick={() => setOpen(false)}>
                            <FaTimes />
                        </button>
                    </div>

                    {/* Messages */}
                    <div className="flex-1 flex flex-col p-3 overflow-y-auto gap-2 text-sm">
                        {messages.map((msg, i) => (
                            <div
                                key={i}
                                className={`max-w-[75%] p-2 rounded-lg ${msg.sender === "user" ? "bg-blue-500 text-white self-end" : "bg-color1 text-white self-start"}`}
                            >
                                {msg.text}
                            </div>
                        ))}
                        <div ref={messagesEndRef} />
                    </div>

                    {/* Footer questions fixes en bas */}
                    <div className="flex gap-2 p-2 border-t border-gray-200 overflow-x-auto bg-white">
                        {faqData.map((q, i) => (
                            <button
                                key={i}
                                className="flex-shrink-0 px-3 py-1 bg-gray-100 rounded-full text-sm hover:bg-gray-200 transition"
                                onClick={() => handleQuestionClick(q)}
                                disabled={typing}
                            >
                                {i + 1}. {q.question}
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </>
    );
};

export default ChatFAQ;